import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';
import { Spring } from 'react-spring';
import SweetAlert from 'sweetalert-react';
import SearchInput from 'components/SearchModal/SearchInput';

import {
  APIHandler,
  StorageHandler,
  BackVideo,
  DataHandler,
  StoreButtons,
  NotificationSlider,
} from 'C4';
import { storageKeys, bgVideo } from 'settings';

import LogoWhite from 'assets/images/logo/logo_white.png';
import bgSoft from 'assets/images/logo/bg-soft.png';

export default class HomeView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: '',
      unreadMessageCount: 0,
      lastCheckedMessages: '1993-01-10',
      appId: -1,
      userStatus: 'startTraining',
      noAgent: false,
    };
  }

  componentWillMount() {
    document.body.classList.add('no-scroll');
    StorageHandler.load(storageKeys.lastCheckedMessage).then((res) => {
      if (res) {
        this.setState({ lastCheckedMessages: res });
      }
      this.checkForUnreadMessages();
    });

    StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        if (res.response.training_graduated) {
          return this.setState({ userStatus: 'graduated' });
        }
        if (res.response.training_started) {
          return this.setState({ userStatus: 'continueTraining' });
        }
      }
      return this.setState({ userStatus: 'startTraining' });
    });
  }

  componentDidMount() {
    const d = new Date(Date.now());
    const leading = (val) => `0${val}`.slice(-2);

    // if (!localStorage.getItem('viewedPopup2')) {
    //   localStorage.setItem('viewedPopup2', true);
    //   setTimeout(() => {
    //     document.getElementById('waves').click();
    //   }, 1000);
    // }
    DataHandler.matchAppId().then((appId) => {
      this.setState({ appId });
      StorageHandler.load(storageKeys.user).then((user) => {
        if (user && user.response.sales_companion_registered === null) {
          const obj = user;
          const date = `${d.getFullYear()}-${leading(
            d.getMonth() + 1
          )}-${leading(d.getDate())}`;

          APIHandler.updateUser(appId, obj.response.email, [
            { param: 'sales_companion_registered', val: date },
          ]).then((res) => {
            if (res) {
              obj.response.sales_companion_registered = date;
              StorageHandler.save(storageKeys.user, obj);
            }
          });
        }
      });
    });
  }

  componentWillUnmount() {
    document.body.classList.remove('no-scroll');
  }

  setQuery() {
    const { query } = this.state;
    if (query.length > 0) {
      StorageHandler.save(storageKeys.lastSearchQuery, query);
    }
  }

  checkForUnreadMessages() {
    DataHandler.requestWithId(
      APIHandler.getUnreadMessages,
      this.state.lastCheckedMessages
    ).then((res) => {
      if (res && res.missed_items && res.missed_items[0]) {
        this.setState({ unreadMessageCount: res.missed_items[0].count });
      }
    });
  }

  render() {
    const { unreadMessageCount, appId, userStatus, noAgent } = this.state;

    const close = () => {
      this.setState({
        noAgent: false,
      });
    };

    return (
      <div className="homeContainer">
        {bgVideo && <BackVideo />}
        {/* <div className="buttonWrapper">
          {i18n.translate("reportCard.download")}
          <StoreButtons />
        </div> */}
        <img src={`/${LogoWhite}`} className="homeLogo" alt="logo" />
        <img src={`/${bgSoft}`} className="bgSoft" alt="bgSoft" />
        <div className="buttonWrapper" />
        <Spring
          from={{ transform: 'translateY(30%)', opacity: 0 }}
          to={{ transform: 'translateY(0%)', opacity: 1 }}
        >
          {(props) => (
            <div className="homeView" style={props}>
              <div className="homeView__title">
                <h1>{i18n.translate('homeScreen.title')}</h1>
                <div className="homeView__title--line" />
                <div className="homeView__title--action">
                  <SearchInput />
                  {appId === 955 && (
                    <style>
                      {
                        '\
                    .buttonBar ul li a { height: 5rem;  } '
                      }
                    </style>
                  )}
                  {appId === 941 && (
                    <style>
                      {
                        '\
                    .buttonBar ul li a { font-size: 1.8rem;  } '
                      }
                    </style>
                  )}
                  <div className="btn-holder">
                    <Link to="/main/showcases" className="showcase-button">
                      <FontAwesomeIcon icon={['fas', 'star']} />
                      <p>{i18n.translate('general.showcase')}</p>
                    </Link>

                    {appId === 633 && (
                      <Link to="/main/rewards" className="rewards-button">
                        <FontAwesomeIcon icon={['fas', 'treasure-chest']} />
                        <p>{i18n.translate('nav.rewards')}</p>
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </Spring>
        <div className="top-bar" />
        <div className="bottom-bar" />

        {/* <NotificationSlider appId={appId} middle right /> */}

        {/* <SweetAlert
          title="This feature is Coming Soon"
          show={noAgent}
          imageUrl={Logo2}
          imageWidth="50rem"
          imageHeight="50rem"
          html
          text=""
          customClass="noAgent"
          showConfirmButton={false}
          cancelButtonText={i18n.translate('general.close')}
          showCancelButton
          onConfirm={close}
          onCancel={close}
          onEscapeKey={close}
          onOutsideClick={close}
        /> */}
      </div>
    );
  }
}
